import { IQualityLevelInfoSchema } from "../../types/QualityLevelInfoSchema";
import { HonestWorkNew } from "../HonestWorkNew";
import * as React from "react";
import { MAX_LEVEL_ORDER } from "./constants";

export interface IHonestWorkWrapperProps {
  qualityLevelInfo?: IQualityLevelInfoSchema | null;
}

export const HonestWorkWrapper = ({
  qualityLevelInfo,
}: IHonestWorkWrapperProps) => {
  console.log(1, { qualityLevelInfo });
  if (
    !qualityLevelInfo ||
    (qualityLevelInfo && qualityLevelInfo.levelOrder < MAX_LEVEL_ORDER)
  ) {
    return null;
  }
  console.log(2, { qualityLevelInfo });

  return <HonestWorkNew />;
};

export default HonestWorkWrapper;



// WEBPACK FOOTER //
// ./src/bundles/honest_work/components/HonestWorkWrapper/HonestWorkWrapper.tsx